import { escapeHTML } from '@lumapps/utils/string/escapeHTML';
import type { HTMLSerializeOptions } from '@lumapps/wrex/serialization/html/toHTML/types';

import type { PlayVideoElement } from '../../types';

export const PLAY_VIDEO_ELEMENTS: HTMLSerializeOptions['elements'] = {
    'play-video': (node: PlayVideoElement) =>
        `<div class="wrex-play-video" data-video-id="${escapeHTML(node.id || '')}" data-video-title="${escapeHTML(
            node.title || '',
        )}"></div>`,
};
